import { Client } from './client';
import { EntityType } from './entity-type';
import { ResidencyJurisdiction } from './residency-jurisdiction';

export class Entity {
  entityId!: number;
  client!: Client;
  clientId!: number;
  residencyJurisdiction!: ResidencyJurisdiction;
  residencyJurisdictionId!: number;
  entityType!: EntityType;
  entityTypeId!: number;
  name!: string;
  description!: string;
  isActive!: boolean;
  created!: Date;
  createdBy!: string;
  modified!: Date;
  modifiedBy!: string;
}
